export const OVERRIDES_PATH = "overrides";
export const OVERRIDE_SAVED_STATE = "override-saved";
export const OVERRIDE_RECIPES_PATH = "recipes";
export const OVERRIDE_HISTORY_PATH = "history";
export const OVERRIDE_ADD_MISSING_PATH = "add-missing";
